import { render, staticRenderFns } from "./TablePortionByDateAndClass.vue?vue&type=template&id=4fe1ed9d&scoped=true&"
import script from "./TablePortionByDateAndClass.vue?vue&type=script&lang=js&"
export * from "./TablePortionByDateAndClass.vue?vue&type=script&lang=js&"
import style0 from "./TablePortionByDateAndClass.vue?vue&type=style&index=0&id=4fe1ed9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1ed9d",
  null
  
)

export default component.exports